import React from "react";

export const Discover = ({ selected }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9416 5.35895L10.7696 7.90962C9.28432 8.27839 7.7785 9.78421 7.40973 11.2695L4.85906 21.4415C4.09078 24.5146 5.97561 26.4097 9.05896 25.6414L19.2309 23.101C20.706 22.7322 22.2221 21.2161 22.5909 19.7411L25.1415 9.55885C25.9098 6.48575 24.0147 4.59068 20.9416 5.35895Z"
        stroke={selected ? "white" : "black"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15 18C16.6569 18 18 16.6569 18 15C18 13.3431 16.6569 12 15 12C13.3431 12 12 13.3431 12 15C12 16.6569 13.3431 18 15 18Z"
        stroke={selected ? "white" : "black"}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CreateShoppingList = ({ selected }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 8.85849V22.9526C24 24.7516 22.7371 25.5084 21.195 24.6399L16.4229 21.9229C15.9129 21.6375 15.0871 21.6375 14.5771 21.9229L9.805 24.6399C8.26286 25.5084 7 24.7516 7 22.9526V8.85849C7 6.73694 8.69999 5 10.7764 5H20.2236C22.3 5 24 6.73694 24 8.85849Z"
        stroke={selected ? "white" : "black"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const GetFeedback = ({ selected }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 6.33782C18.5291 5.48697 16.8214 5 15 5C9.47715 5 5 9.47715 5 15C5 16.5997 5.37562 18.1116 6.04346 19.4525C6.22094 19.8088 6.28001 20.2161 6.17712 20.6006L5.58151 22.8267C5.32295 23.793 6.20701 24.677 7.17335 24.4185L9.39939 23.8229C9.78393 23.72 10.1912 23.7791 10.5475 23.9565C11.8884 24.6244 13.4003 25 15 25C20.5228 25 25 20.5228 25 15C25 13.1786 24.513 11.4709 23.6622 10"
        stroke={selected ? "white" : "black"}
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M10 15H10.0112M14.9887 15H15M19.9887 15H20"
        stroke={selected ? "white" : "black"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const InviteFriends = ({ selected }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9995 12.5005C16.7609 12.5005 18.9995 10.2619 18.9995 7.50049C18.9995 4.73906 16.7609 2.50049 13.9995 2.50049C11.2381 2.50049 8.99951 4.73906 8.99951 7.50049C8.99951 10.2619 11.2381 12.5005 13.9995 12.5005Z"
        stroke={selected ? "white" : "black"}
        stroke-width="2"
      />
      <path
        d="M23.282 14.9997V12.9691H21.2505C20.9917 12.9691 20.7819 12.759 20.7817 12.5003C20.7817 12.2414 20.9916 12.0316 21.2505 12.0316H23.282V10C23.282 9.74112 23.4919 9.53125 23.7508 9.53125C24.0095 9.53141 24.2195 9.74122 24.2195 10V12.0316H26.2502L26.3454 12.0407C26.5588 12.0846 26.7189 12.2739 26.7189 12.5003C26.7188 12.7265 26.5587 12.9151 26.3454 12.959L26.2502 12.9691H24.2195V14.9997C24.2195 15.2585 24.0095 15.4683 23.7508 15.4684C23.4919 15.4684 23.282 15.2586 23.282 14.9997Z"
        stroke={selected ? "white" : "black"}
        stroke-linecap="round"
      />
      <path
        d="M23.9969 22.5C24 22.2948 24 22.0862 24 21.875C24 18.7684 19.5229 16.25 14 16.25C8.47715 16.25 4 18.7684 4 21.875C4 24.9816 4 27.5 14 27.5C16.7887 27.5 18.7997 27.3041 20.25 26.9543"
        stroke={selected ? "white" : "black"}
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};
